module.exports = __webpack_public_path__ + "img/refresh-two-counterclockwise-circular-arrows-interface-symbol.4e57ea98.svg";